module.exports = __webpack_public_path__ + "img/9791161727073.d5677e54.jpg";